/** Last N calendar months as `{ value: 'YYYY-MM', label: 'Month Year' }`. */
export function buildAdminMonthOptions(count = 12) {
  const current = new Date();
  const options = [];

  for (let i = 0; i < count; i++) {
    const date = new Date(current.getFullYear(), current.getMonth() - i, 1);
    options.push({
      value: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`,
      label: date.toLocaleString("default", {
        month: "long",
        year: "numeric",
      }),
    });
  }

  return options;
}

export function currentAdminMonthValue() {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function voteCountLabel(monthValue, monthOptions) {
  if (!monthValue) return "All-time votes";
  const match = monthOptions.find((item) => item.value === monthValue);
  return match ? `Votes in ${match.label}` : "Votes this month";
}
